import { render, staticRenderFns } from "./VipCardDiscountConfirm.vue?vue&type=template&id=c6710288&scoped=true"
import script from "./VipCardDiscountConfirm.vue?vue&type=script&lang=js"
export * from "./VipCardDiscountConfirm.vue?vue&type=script&lang=js"
import style0 from "./VipCardDiscountConfirm.vue?vue&type=style&index=0&id=c6710288&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6710288",
  null
  
)

export default component.exports